<template>
  <div id="app" :class="{ 'dark-mode': darkMode }">
    <!-- 可以让img标签预加载网络图片,主要作用于装修攻略富文本网络图片加载 -->
    <meta name="referrer" content="no-referrer" />
    <!-- heaedr -->
    <header-bar v-if="$route.meta.headerShow"></header-bar>
    <!-- 个人中心侧边栏相关页面 -->
    <div :class="{ 'personalCenter-show': $route.meta.sidebarShow }">
      <div :class="{ 'main-content': $route.meta.sidebarShow }">
        <personal-sidebar
          ref="sideBar"
          v-if="$route.meta.sidebarShow"
        ></personal-sidebar>
        <router-view />
        <!--keep-alive 暂不满足需求
        路由的v-if可能会影响预渲染  -->
        <!-- <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view> -->
      </div>
    </div>
    <!-- footer -->
    <footer-bar
      v-if="$route.meta.footerShow"
      :hideAds="$route.meta.hideAds || false"
    ></footer-bar>

    <!-- 回到顶部 -->
    <div
      v-if="$route.meta.footerShow || $route.meta.backTopShow"
      class="backTop"
      @click="backTop"
    >
      <img src="./assets/images/back_top.png" alt />
      <p>返回顶部</p>
    </div>
  </div>
</template>

<script>
import header from "./components/header.vue";
import footer from "./components/footer.vue";
import personalSidebar from "./components/personalSidebar.vue";

import axios from "axios";
import router from "./router";
import * as indexApi from "@/api/indexApi";

export default {
  name: "App",
  components: {
    "header-bar": header,
    "footer-bar": footer,
    "personal-sidebar": personalSidebar,
  },
  data() {
    return {
      ajaxRequestNum: 0,
      darkMode: false, //黑白主题
    };
  },
  // 登录页面iframe设置本地储存 跳转主页 刷新后，才能获取到本地储存
  watch: {
    $route(to, from) {
      // console.log('watch',to, from)
      if (from.path == "/login" && from.path != to.path) {
        //跳转到哪个页面
        location.reload();
      }
    },
  },
  methods: {
    // 刷新个人中心侧边栏
    changeSidebar() {
      this.$refs.sideBar.showNavigation();
    },
    backTop: function () {
      let top = document.documentElement.scrollTop; // 实现滚动效果
      const timeTop = setInterval(() => {
        document.documentElement.scrollTop = document.body.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop); //清除定时器
        }
      }, 10);
    },
    // 提示微信用户绑定手机号
    toBindPhone() {
      this.$confirm("您还没有绑定手机号", "", {
        confirmButtonText: "去绑定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$router.push({
            path: "/login",
            query: { type: "bindPhone", redirect: this.$route.fullPath },
          });
        })
        .catch(() => {});
      // this.$message.warning("您还没有绑定手机号，请先绑定手机号！");
      // this.$router.push("/login?type=bindPhone");
    },
    toRealName() {
      this.$confirm("您还没有实名认证", "", {
        confirmButtonText: "去认证",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$router.push({
            path: "/personalCenter/personalData",
            query: { type: "realName" },
          });
        })
        .catch(() => {});
    },
  },
  mounted() {},
  created: function () {
    // 是否设置主题黑白
    indexApi.findDarkMode().then((res) => {
      if (res.data.code == "200") {
        this.darkMode = res.data.data;
        if (this.darkMode) {
          document.documentElement.className = "dark-mode"; //根元素html添加该类 避免影响弹框样式
        }
      }
    });
    // 获取当前路由
    // 进入个人中心相关页面，提示微信用户绑定手机号，关于项目操作需要实名（loading）
    if (location.hash.indexOf("/personalCenter") != -1) {
      if (localStorage.getItem("phoneTrue") == "false") {
        this.toBindPhone();
        return false;
      }
    }
    if (
      location.hash.indexOf("/personalCenter") != -1 &&
      location.hash.indexOf("/personalCenter/personalData") == -1
    ) {
      if (
        localStorage.getItem("idCardIsTrue") == "false" ||
        localStorage.getItem("idCardIsTrue") == "0"
      ) {
        this.$router.push("/index");
        // return false;//下面监控路由要继续执行
      }
    }
    let _this = this;
    //路由变更重置ajaxRequestNum
    router.beforeEach((to, from, next) => {
      if (
        (to.fullPath.indexOf("/regulationTheScene") != -1 &&
          to.fullPath.indexOf("/regulationTheScene/") == -1) ||
        to.fullPath.indexOf("/service") != -1 ||
        (from.path == "/regulationTheScene/viewStandardDetails" &&
          to.path.indexOf("/regulationTheScene/particulars") != -1) ||
        (to.path == "/siteList" &&
          from.path.indexOf("/regulationTheScene/particulars") != -1)
      ) {
      } else {
        this.backTop();
      }
      // 强制缓存
      console.log(from.path, to.path);
      // if (
      //   from.path == "/regulationTheScene/viewStandardDetails" &&
      //   to.path.indexOf("/regulationTheScene/particulars") != -1
      // ) {
      //   to.meta.keepAlive = true;
      // } else {
      //   to.meta.keepAlive = false;
      // }
      if (to.fullPath.indexOf("/personalCenter") != -1) {
        if (localStorage.getItem("phoneTrue") == "false") {
          this.toBindPhone();
          return false;
        }
      }
      if (
        to.fullPath.indexOf("/personalCenter") != -1 &&
        to.fullPath.indexOf("/personalCenter/personalData") == -1
      ) {
        if (
          (localStorage.getItem("idCardIsTrue") == "false" ||
            localStorage.getItem("idCardIsTrue") == "0") &&
          localStorage.getItem("role") != "USER"
        ) {
          this.toRealName();
          return false;
        }
      }

      if (to.name !== from.name) {
        _this.ajaxRequestNum = 0;
      }

      next();
    });

    //添加一个请求拦截器
    axios.interceptors.request.use(
      function (config) {
        //在请求发出之前进行一些操作
        _this.ajaxRequestNum++;
        return config;
      },
      function (error) {
        //Do something with request error
        return Promise.reject(error);
      }
    );

    //添加一个响应拦截器
    axios.interceptors.response.use(
      function (res) {
        // 请求成功统一处理
        // console.log(_this.$route.fullPath)
        _this.ajaxRequestNum--;
        if (res.data.code == 503) {
          //503不提示异常 强制跳转
          localStorage.removeItem("sessionId");
          localStorage.removeItem("userid");
          localStorage.removeItem("role");
          localStorage.removeItem("roleLevel");
          localStorage.removeItem("phoneTrue");
          localStorage.removeItem("idCardIsTrue");

          _this.$router.push({
            path: "/login",
            query: { redirect: _this.$route.fullPath },
          });
        } else if (res.data.code == 502) {
          //不处理异常
        } else if (res.data.code != 200) {
          //501展示异常
          // _this.$message.error(res.data.msg, 3);
          _this.$alert(res.data.msg, "", {
            confirmButtonText: "确定",
          });
        }
        return res;
      },
      function (error) {
        //请求失败统一处理
        _this.ajaxRequestNum--;

        if (error.response) {
          switch (error.response.status) {
            case 401:
              _this.$message.error("您的登录状态已失效，请重新登录", 3);

              break;
            case 404:
              _this.$message.error("接口地址找不到了，若无影响，请忽略", 3);
              break;

            case 502:
              _this.$message.error("服务器正在重启", 3);
              break;
            case 504:
              _this.$message.error("请求超时", 3);
              break;
            default:
              _this.$message.error(error.response.data.error.description, 3);
              break;
          }
        }
        return Promise.reject(error);
      }
    );
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  outline: none;
}
// 黑白主题
.dark-mode {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
}
html {
  // font-size: 28px;
}
// 隐藏浏览器滚动条 火狐不支持
// ::-webkit-scrollbar {
//   width: 0px;
// }
html,
body {
  min-width: 1400px;
  padding: 0;
  margin: 0;
  // overflow-x: hidden;
}

li {
  list-style-type: none;
}
a {
  text-decoration: none;
  color: #333;
}
em,i{
  font-style: normal;
}
b,strong{
  font-weight: normal;
}
//恢复富文本中样式
.section-line-fwb{
  em,i{
    font-style: italic;
  }
  b,strong{
    font-weight: bold;
  }
}
.ql-editor{
  em,i{
    font-style: italic;
  }
  b,strong{
    font-weight: bold;
  }
}
// tinymce
.tox-silver-sink {
  z-index: 4000 !important;
}
// 富文本对齐设置
.ql-align-right {
  text-align: right !important;
}
.ql-align-center {
  text-align: center !important;
}
.ql-align-justify {
}
#app {
  font-family: Microsoft YaHei;
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  // 字体抗锯齿
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  color: #333;
  // background-color: #f3f3f3;
}
.cur-pointer:hover {
  cursor: pointer;
}
//允许事件点击穿透
.overlay {
  pointer-events: none;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.fz30 {
  font-size: 30px;
}
.fz24 {
  font-size: 24px;
}
.fz18 {
  font-size: 18px;
}
.fz14 {
  font-size: 14px;
}
.fz12 {
  font-size: 12px;
}
.fz16 {
  font-size: 16px;
}
.fw-bold {
  font-weight: bold;
}
.color-333 {
  color: #333;
}
.color-666 {
  color: #666;
}
.color-theme {
  color: #a20a0e;
}
.margin-lf40 {
  margin-left: 40px;
}

/* 1200px主视图区域 */
.main-content {
  width: 1200px;
  margin: 0 auto;
}
.over-hidden {
  overflow: hidden;
}
.tab-active {
  color: #fff !important;
  background: #a20a0e !important;
}
// viewer 隐藏底部图片信息title
.viewer-title {
  display: none !important;
}
// 报错 确认弹框
.el-message-box {
  .el-icon-close:hover {
    color: #909399 !important;
  }
  .el-button--default {
    background: #fff !important;
  }
  .el-button--default:hover {
    color: #606266 !important;
    border-color: #dcdfe6 !important;
  }

  .el-button--primary,
  .el-button--primary:hover {
    background: #a20a0e !important;
    border-color: #a20a0e !important;
    color: #fff !important;
  }
}
//平行四边形 定位 装饰
.parallelogram {
  width: 134px;
  height: 16px;
  background: rgba(255, 120, 124, 1);
  opacity: 0.6;
  transform: skewX(30deg);
  position: absolute;
  bottom: 4px;
  right: 0;
}

// 回到顶部
.backTop {
  width: 78px;
  height: 78px;
  background: rgba(29, 29, 29, 1);
  opacity: 0.5;
  border-radius: 10px;

  text-align: center;

  position: fixed;
  bottom: 104px;
  right: 104px;
  z-index: 4;

  font-size: 14px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  img {
    width: 36px;
    height: 39px;
    margin-top: 10px;
  }
}
.upload-box {
  .el-input,
  .el-input__inner {
    width: 180px !important;
  }
}
// 全部表单元素去除激活边框颜色
.el-input__inner:focus {
  border-color: #dcdfe6 !important;
}
.el-textarea__inner:focus {
  border-color: #dcdfe6 !important;
}
// 全部checkbox
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #a20a0e;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #a20a0e;
  border-color: #a20a0e;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #dcdfe6;
}
/*type number 隐藏加减*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
// 超过一行展示省略号
.over-one {
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /*autoprefixer: on */
  -webkit-line-clamp: 1;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
}
// 内容为空的提示
.empty-tips {
  font-size: 16px;
  color: #666;
  text-align: center;
  padding: 60px 0;
}
// 单选
.el-radio__input.is-checked + .el-radio__label {
  color: #a20a0e;
}
.el-radio__input.is-checked .el-radio__inner {
  background: #a20a0e;
  border-color: #a20a0e;
}
.el-radio__inner:hover {
  border-color: #a20a0e;
}
// 登录页
.login {
  .el-input {
    width: 280px;
    float: left;
  }
  .el-input__inner {
    width: 280px;
    height: 60px;
    border: none;
    font-size: 20px;
  }
  .verification-input {
    .el-input {
      width: 160px;
    }
    .el-input__inner {
      width: 160px;
      padding-left: 4px;
    }
  }
}

// 首页-免费预约
.free-admission {
  .el-input__inner {
    width: 262px;
    height: 62px;
    margin-left: 12px;
    font-size: 24px;
    font-weight: normal;
  }
  .input-plus .el-input__inner {
    width: 360px;
  }

  .el-button--primary {
    border-color: #fff;
  }
  // 地址选择-插件
  .distpicker-address-wrapper {
    width: 540px;
    display: inline-block;
    margin-left: 12px;
    select {
      width: 168px;
      height: 62px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      font-size: 24px;
      color: #606266;
      option {
        // 原生不能设置行高
        font-size: 14px;
      }
    }
  }
}

// 首页-装修技术咨询
.ask-module {
  .el-form-item {
    .el-form-item__content {
      font-size: 22px;
      height: #666;
      width: 500px;
      .el-select {
        width: 100%;
      }
      .el-input__inner {
        height: 56px;
      }
    }
  }
  .ql-editor {
    height: 200px;
    img {
      width: 100px;
    }
    iframe {
      width: 192px;
      height: 108px;
    }
  }
}

// 首页-走马灯banner
.carousel-box {
  .el-carousel__mask {
    background-color: #000;
    opacity: 0.5;
    z-index: 1;
  }
}
// 加入我们详情
.join-us {
  .require-content {
    .cell {
      padding: 0;
    }
    thead {
      color: #333;
      font-size: 24px;
      th {
        height: 60px;
        background: rgba(249, 249, 249, 1);
      }
      th:first-child {
        padding-left: 30px;
        box-sizing: border-box;
      }
      th:last-child {
        color: #a20a0e !important;
        padding-right: 30px;
        box-sizing: border-box;
      }
    }
    tbody {
      td {
        height: 84px;
        border-bottom: 1px solid #f9f9f9;
        font-size: 22px;
        color: #333;
      }
      td:first-child {
        color: #a20a0e !important;
        padding-left: 30px;
        box-sizing: border-box;
      }
      td:last-child {
        color: #a20a0e !important;
        padding-right: 30px;
        box-sizing: border-box;
      }
      tr:hover td {
        background: #fff2f2;
      }

      .el-table__expand-icon {
        color: #a20a0e;
        font-size: 14px;
      }
    }
    .el-table__body tr.current-row > td {
      background: #fff2f2;
    }
    // 分页
    .el-pagination.is-background .el-pager li {
      width: 22px;
      font-size: 18px;

      border-radius: 50%;
      color: #333;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      width: 22px;
      font-size: 18px;
      background: #a20a0e;
      color: #fff;
    }
    .btn-next,
    .btn-prev {
      background: #a20a0e;
      color: #fff;
      padding: 0 10px;
    }

    .btn-next:disabled,
    .btn-prev:disabled {
      color: #a20a0e;
      background: none;
      border: 1px solid #a20a0e;
    }
  }
}
// 填写简历
.write-resume {
  .content-right {
    .el-input {
      width: 388px;
      height: 40px;
      color: #626262;
      border-color: #626262;
      margin-bottom: 30px;
    }
    .el-textarea {
      color: #626262;
      border-color: #626262;
      margin-bottom: 30px;
    }
    .mini .el-input {
      width: 260px !important;
    }

    .el-input__inner:focus {
      border-color: #a20a0e !important;
    }

    .el-textarea__inner:focus {
      border-color: #a20a0e !important;
    }
    .el-range-editor.is-active,
    .el-range-editor.is-active:hover {
      border-color: #a20a0e !important;
    }
    input::-webkit-input-placeholder,
    textarea::-webkit-input-placeholder {
      color: #a20a0e;
    }
    input::-moz-input-placeholder,
    textarea::-webkit-input-placeholder {
      color: #a20a0e;
    }
    input::-ms-input-placeholder,
    textarea::-webkit-input-placeholder {
      color: #a20a0e;
    }
  }
}
//免费预约组件
.freeBookingBox {
  // 免费预约弹框
  .el-dialog {
    height: 624px;
    background: url("./assets/images/bg1.png") no-repeat center/100% 100%;
    .el-icon-close {
      color: #fff;
      width: 16px;
      height: 16px;
      border: 1px solid #fff;
      border-radius: 50%;
      display: inline-block;
      -webkit-transform: scale(2);
      -moz-transform: scale(2);
      -o-transform: scale(2);
      opacity: 0.8;
    }
    .el-dialog__body {
      width: 100%;
      height: 570px;
      overflow: hidden;
      padding: 0 !important;
      margin-top: 24px;
      .el-input__inner {
        width: 419px;
        height: 42px !important;
        margin-left: 12px;
        font-size: 16px;
        font-weight: normal;
        margin: 0;
        color: #333;
      }
      input::-webkit-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #616161;
      }
      input::-moz-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #616161;
      }
      input::-ms-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #616161;
      }

      // // 地址选择-插件
      .distpicker-address-wrapper {
        width: 100%;
        display: flex;
        margin-bottom: 22px;
        select {
          flex: 1;
          height: 42px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
          font-size: 16px;
          color: #616161;
          padding: 0;
          padding-left: 12px;

          option {
            // 原生不能设置行高
            font-size: 14px;
          }
        }
        select:nth-child(2) {
          margin: 0 3px;
        }
      }
    }
    .el-input__suffix {
      top: 0;
    }
    .el-input__icon {
      height: auto;
    }
  }
}
// 套餐服务
.optionalSupervision {
  .el-input__inner {
    // width: 400px;
    height: 62px;
    font-size: 24px;
  }

  .dialog1 {
    .el-dialog {
      background: url("./assets/images/bg1.png") no-repeat center/100% 100%;
      .el-icon-close {
        color: #fff;
        width: 16px;
        height: 16px;
        border: 1px solid #fff;
        border-radius: 50%;
        display: inline-block;
        -webkit-transform: scale(2);
        -moz-transform: scale(2);
        -o-transform: scale(2);
        opacity: 0.8;
      }
    }
  }
  .dialog2 {
    .el-dialog {
      min-height: 700px;
      margin-top: 5vh !important;
      background-image: url("./assets/imagesSer/ser_bg17.png");
      background-position: top;
      background-repeat: no-repeat;
      background-size: 100%;
      background-color: transparent;
      .el-dialog__body {
        padding: 0px !important;
      }
      .el-dialog__headerbtn .el-icon-close {
        color: #a5a5a5;
        width: 16px;
        height: 16px;
        border: 1px solid #a5a5a5;
        border-radius: 50%;
        display: inline-block;
        -webkit-transform: scale(2);
        -moz-transform: scale(2);
        -o-transform: scale(2);
        opacity: 0.8;
        position: absolute;
        top: 162px;
        right: 10px;
      }
    }
  }
}
.appointment-box {
  .el-input__inner {
    width: 407px;
    height: 46px;
    font-size: 22px;
  }
  .el-dialog {
    width: 1101px;
    height: 659px;
    background: url("./assets/imagesSer/ser_bg3.png") no-repeat center/100% 100%;
    .el-icon-close {
      display: inline-block;
      color: #666;
      width: 16px;
      height: 16px;
      border: 1px solid #666;
      border-radius: 50%;
      -webkit-transform: scale(1.5);
      -moz-transform: scale(1.5);
      -o-transform: scale(1.5);
      opacity: 0.8;
      position: absolute;
      top: 166px;
      right: 52px;
    }
    .el-dialog__body {
      width: 100%;
      // height: 100%;
    }
  }
}
// 注册
.write-register {
  .content-right {
    .el-input {
      width: 520px;
      height: 60px;
      color: #626262;
      border: none;
      margin-top: 30px;
    }
    .el-input__inner {
      padding-left: 45px;
      height: 60px;
      font-size: 20px;
      box-shadow: none;
      border: 1px solid rgba(234, 232, 235, 1);
      border-radius: 40px; //圆角
    }
    .form-code .el-input {
      position: absolute;
      left: 0;
      top: 0;
      width: 320px;
      height: 60px;
    }
    .el-input__suffix {
      right: 30px;
    }
    .mini .el-input {
      width: 260px !important;
    }
    //鼠标选中效果
    .el-input__inner:hover {
      border-color: #fff !important;
      box-shadow: 0px 8px 16px 0px rgba(104, 104, 104, 0.08);
    }
  }
}
// 服务
.regulatoryServices,
.add-service {
  /*滚动条样式*/
  ::-webkit-scrollbar {
    /*滚动条整体样式*/

    width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }

  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/

    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    // background: #a20a0e;
    background: rgba(0, 0, 0, 0.2);
  }

  ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/

    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}
// 个人中心app的类
.personalCenter-show {
  width: 100%;
  overflow: hidden;
  background: #f3f3f3;
  padding-bottom: 80px;
  box-sizing: border-box;

  // 地址
  // 地址选择-插件
  .distpicker-address-wrapper {
    height: 32px;
    display: inline-block;
    margin-right: 12px;
    select {
      width: 120px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      font-size: 16px;
      color: #606266;
      padding: 0;
      padding-left: 12px;
      option {
        // 原生不能设置行高
        font-size: 14px;
      }
    }
  }

  // 个人资料
  // .personal-data {
  .el-input {
    height: 32px !important;
  }
  .el-input__inner {
    height: 32px !important;
  }
  .el-input__prefix {
    margin-top: -4px;
  }
  .el-input__suffix {
    top: -4px;
  }
  // }
  // 修改头像 联系监理
  .headDialog,
  .personal-mainPage {
    .el-dialog {
      border-radius: 4px !important;
      .el-dialog__title {
        font-weight: bold;
      }

      .el-icon-close {
        display: inline-block;
        color: #666;
        width: 16px;
        height: 16px;
        border: 1px solid #666;
        border-radius: 50%;
        -webkit-transform: scale(1.5);
        -moz-transform: scale(1.5);
        -o-transform: scale(1.5);
        opacity: 0.8;
      }
    }
  }
  //个人中心-dialog
  .personal-mainPage {
    .box-title {
      .el-input {
        float: right;
      }
      .el-input,
      .el-input__inner {
        display: inline-block;
        width: 240px;
        height: 35px !important;
        font-size: 16px;
      }
    }
    .el-dialog__title {
      font-size: 24px;
    }
    .el-dialog__body {
      padding: 10px 30px 40px 30px;
      position: relative;
      .dialog-tip {
        position: absolute;
        top: -34px;
        left: 102px;
      }
    }
    .contact-dialog,
    .budget-dialog {
      /*滚动条样式*/
      ::-webkit-scrollbar {
        /*滚动条整体样式*/

        width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 4px;
      }

      ::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/

        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        // background: #a20a0e;
        background: rgba(0, 0, 0, 0.2);
      }

      ::-webkit-scrollbar-track {
        /*滚动条里面轨道*/

        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }
      // 输入框
      .el-textarea__inner {
        background: #f3f3f3;
        border: none;
        border-radius: 6px;
        color: #666666;
        font-size: 16px;
      }
      // 选择框
      .el-input,
      .el-input__inner {
        width: 300px;
        height: 40px !important;
        font-size: 16px;
      }
      .el-input {
        margin: 20px 0;
      }

      // 上传图片
      .chat-img {
        .upload-demo,
        .el-upload--picture {
          float: left;
          width: 148px;
          height: 148px;
          line-height: 148px;
          background: #f3f3f3;
          border-radius: 6px;
          text-align: center;
          font-size: 22px;
          color: #606266;
        }
      }
    }
  }
}
// 个人中心-监理-新建项目
.new-project {
  .el-input__inner,
  .el-textarea__inner {
    font-size: 16px !important;
  }
  .input-item-special {
    .el-date-editor {
      width: 100%;
    }
  }
  .el-checkbox-group {
    margin-top: 22px;
  }
}
// 个人中心-监理-装修记录上传
.decoration-record {
  thead {
    font-size: 18px;
    .cell {
      text-align: center;
      font-weight: 400;
      color: #333;
    }

    th {
      height: 40px;
      background: rgba(249, 249, 249, 1);
    }
    th:nth-child(even) {
      background: #ebebeb;
    }
  }
  tbody {
    font-size: 18px;
    td {
      height: 60px;
      border-bottom: 1px solid #f3f3f3;
      text-align: center;
      i {
        color: #a6a6a6;
      }
    }
  }
  .el-table__body tr.current-row > td {
    background: #fff2f2;
  }
}
//个人中心-监理-装修记录上传-添加监理记录
.decoration-recordUpload {
  // 富文本
  .quill-editor {
    width: 100%;
  }
  .ql-editor {
    height: 180px;
    font-size: 16px;
  }
  .record-dialog,
  .preview-dialog {
    .el-dialog {
      padding: 30px;
      .el-dialog__header{
        padding: 0;
        padding-bottom: 15px;
      }
      .el-dialog__body {
        padding: 0;
      }
      border-radius: 4px !important;
      .el-dialog__title {
        font-size: 22px;
        font-weight: bold;
      }

      .el-icon-close {
        display: inline-block;
        color: #666;
        width: 16px;
        height: 16px;
        border: 1px solid #666;
        border-radius: 50%;
        -webkit-transform: scale(1.5);
        -moz-transform: scale(1.5);
        -o-transform: scale(1.5);
        opacity: 0.8;
      }
    }
    /*滚动条样式*/
    ::-webkit-scrollbar {
      /*滚动条整体样式*/

      width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 4px;
    }

    ::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/

      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      // background: #a20a0e;
      background: rgba(0, 0, 0, 0.2);
    }

    ::-webkit-scrollbar-track {
      /*滚动条里面轨道*/

      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background: rgba(0, 0, 0, 0.1);
    }

    // 选择框
    .el-input,
    .el-input__inner {
      width: 400px;
      height: 40px !important;
      font-size: 16px;
    }
  }
  .preview-dialog {
    .el-dialog {
      .el-dialog__body {
        padding: 0;
        padding-bottom: 20px;
      }
    }
  }
}
// 添加样式
.optionsColor {
  //  /deep/ .el-select-dropdown__item {
  color: #a20a0e !important;
}
.optionsBorder {
  border-bottom: 1px dashed rgb(141, 141, 141);
}
.optionsBorder:last-child {
  border-bottom: none;
}
.optionsHide {
  display: none;
}
// 常用公共样式*************************************************************************

// 分页-正方红色
.personal-mainPage,
.project-news,
.system-news,
.received-comments,
.received-praise,
.my-comments,
.decoration-record,
.retse,
.particulars,
.risk,
.riskdetails,
.bad,
.view-process {
  .refuse-dialog {
    .ql-container.ql-snow {
      height: 140px !important;
    }
  }
  .el-pagination.is-background .el-pager li {
    width: 22px;
    font-size: 18px;
    color: #333;
    font-weight: normal;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    width: 22px;
    font-size: 14px;
    background: #a20a0e;
    color: #fff;
    font-weight: normal;
  }
  .btn-next,
  .btn-prev {
    padding: 0 10px;
    color: #333;
  }

  .btn-next:disabled,
  .btn-prev:disabled {
    background: none;
    color: #333;
  }
}
// page
.refuse-dialog {
  .ql-container.ql-snow {
    height: 140px !important;
  }
}
.el-pagination.is-background .el-pager li {
  width: 22px;
  font-size: 18px;
  color: #333;
  font-weight: normal;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  width: 22px;
  font-size: 14px;
  background: #a20a0e;
  color: #fff;
  font-weight: normal;
}
.btn-next,
.btn-prev {
  padding: 0 10px;
  color: #333;
}

.btn-next:disabled,
.btn-prev:disabled {
  background: none;
  color: #333;
}
// 弹框
.wxpay,
.paytoViewDialog,
.view-process,
.view-budget,
.view-contract,
.view-drawing {
  .el-dialog {
    .el-dialog__body {
      padding-top: 10px;
    }
    border-radius: 4px !important;
    .el-dialog__title {
      font-size: 22px;
      font-weight: bold;
    }

    .el-icon-close {
      display: inline-block;
      color: #666;
      width: 16px;
      height: 16px;
      border: 1px solid #666;
      border-radius: 50%;
      -webkit-transform: scale(1.5);
      -moz-transform: scale(1.5);
      -o-transform: scale(1.5);
      opacity: 0.8;
    }
  }
}
// 滚动条
.casedetails,
.view-process,
.particulars,
.view-budget,
.view-contract,
.view-drawing,
.stylist,
.long-service {
  /*滚动条样式*/
  ::-webkit-scrollbar {
    /*滚动条整体样式*/

    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }
  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/

    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    // background: #a20a0e;
    background: rgba(0, 0, 0, 0.1);
  }

  ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/

    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.05);
  }
}
.particulars {
  ::-webkit-scrollbar {
    /*滚动条整体样式*/

    width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }
}
//个人中心- 查看进程
.view-process {
  .setuser-dialog {
    .el-input,
    .el-input__inner {
      width: 300px;
      float: left;
      font-size: 16px;
    }
    .el-input {
      margin-left: 190px;
    }
  }

  .el-textarea__inner {
    font-size: 16px;
    background: #f3f3f3;
  }
}
// 监理详情折叠面板
.particulars {
  .el-collapse-item__header {
    padding-left: 20px;
    font-size: 16px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
}
// 面包屑
.particulars,
.retse {
  .el-breadcrumb {
    font-size: 20px;
  }
}
.particulars {
  .el-carousel__arrow {
    border-radius: 0%;
    height: 80px;
    width: 25px;
    background-color: #a20a0e;
  }
  .main-img {
    .el-carousel__arrow {
      border-radius: 0%;
      height: 80px;
      width: 25px;
      background: rgba(19, 19, 19, 0.6);
    }
  }
  .sj-table {
    td {
      border: 1px solid #999 !important;
      font-size: 14px !important;
      padding: 4px !important;
    }
  }
}
// 预算
.view-budget,
.view-process,
.view-contract,
.view-drawing {
  .budget-dialog {
    .el-input,
    .el-input__inner {
      width: 340px;
      font-size: 16px;
    }
    .budget-name {
      .el-input,
      .el-input__inner {
        width: 484px;
        font-size: 16px;
      }
    }
  }
}
// 阅读协议组件
.readingProtocolDialog {
  .el-dialog {
    margin-top: 4vh !important;
  }
  .el-dialog__body {
    /*滚动条样式*/
    ::-webkit-scrollbar {
      /*滚动条整体样式*/

      width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 4px;
    }

    ::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/

      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      // background: #a20a0e;
      background: rgba(0, 0, 0, 0.2);
    }

    ::-webkit-scrollbar-track {
      /*滚动条里面轨道*/

      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background: rgba(0, 0, 0, 0.1);
    }
  }
  // 富文本
  .quill-editor {
    width: 100%;
    margin-top: 20px;
    // background: #f3f3f3;
  }
  .ql-editor {
    height: 120px;
    font-size: 16px;
  }
}
.view-budget {
  .table-content {
    ::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 6px;
    }
    ::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 12px;
    }
  }
}
// 新增项目页面
.stages-list {
  .el-table td {
    padding: 3px 0;
  }
  .el-input,
  .el-input__inner {
    border: none;
    background: none;
  }
}
//折叠
.decoration-recordUpload {
  .el-collapse-item__header,
  .el-collapse-item__content {
    background: #f3f3f3;
    // border-bottom: 2px solid #e2e2e2;
  }
}
// 编辑图片
.img-edit {
  .el-select {
    width: 80px;
    margin-left: 6px;
  }
  .el-input__inner {
    height: 30px;
  }
  .el-input__icon {
    line-height: 30px !important;
  }
}
img[lazy="loading"] {
  width: 30px !important;
  height: 30px !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
// // 实际图片大小
// img[lazy="loaded"] {
//   width: 100% !important;
//   height: 100% !important;
// }
//新监理现场详情滚动条
.styleList{
  &::-webkit-scrollbar{
    width: 8px;
  }
  &::-webkit-scrollbar-thumb{
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track{
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: rgba(0, 0, 0, 0.05);
  }
}
.styleList2{
  &::-webkit-scrollbar{
    width: 8px;
  }
  &::-webkit-scrollbar-thumb{
    box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.15);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track{
    box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.1);
  }
}
.styleList3{
  &::-webkit-scrollbar{
    width: 7px;
  }
  &::-webkit-scrollbar-thumb{
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: #BFBFBF;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track{
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: #EEEEEE;
    border-radius: 4px;
  }
}
.color-red{
  color: #DE282E;
}
.margin-auto{
  margin: 0 auto;
}
.border-box{
  box-sizing: border-box;
}
.h-page{
  .el-pagination .btn-prev span, .el-pagination .btn-next span{
    padding: 0 14px;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue